// 规划占位页 — 菜单已按业务流程补齐, 但对应后端能力尚未落地的模块.
//
// 诚实占位: 明确「本页要做什么 + 后端现状」, 避免空白页误导运营以为功能坏了.
// 后端接口落地后, 各页替换为真实实现.

import { Alert, Card, List, Space, Typography } from 'antd';
import { ToolOutlined } from '@ant-design/icons';

export interface PlaceholderPageProps {
  title: string;
  /** 本模块在业务流程里承担什么. */
  description: string;
  /** 规划中的功能点. */
  planned: string[];
  /** 后端现状 — ready=已有接口只差前端; false=接口待建. */
  backend: { ready: boolean; note: string };
}

export function PlaceholderPage({ title, description, planned, backend }: PlaceholderPageProps) {
  return (
    <Space direction="vertical" size="large" style={{ width: '100%' }}>
      <div>
        <Space align="center">
          <ToolOutlined style={{ fontSize: 20, color: '#999' }} />
          <Typography.Title level={4} style={{ margin: 0 }}>
            {title}
          </Typography.Title>
          <Typography.Text type="secondary">规划中</Typography.Text>
        </Space>
        <Typography.Paragraph type="secondary" style={{ marginTop: 8 }}>
          {description}
        </Typography.Paragraph>
      </div>

      <Alert
        type={backend.ready ? 'info' : 'warning'}
        showIcon
        message={backend.ready ? '后端接口已就绪 — 待接前端' : '后端接口待建'}
        description={backend.note}
      />

      <Card size="small" title="规划功能">
        <List
          size="small"
          dataSource={planned}
          renderItem={(item) => (
            <List.Item>
              <Typography.Text>· {item}</Typography.Text>
            </List.Item>
          )}
        />
      </Card>
    </Space>
  );
}
